<template>
  <div class="bid-now" v-loading="loading">
    <div style="flex:1 0 0;">
      <div class="bid-title">
        <div class="spaceCenter">
          <!-- <svg-icon class="icon" aria-hidden="true" icon-class="trn-jingbiao" /> -->
           <img src="@/assets/image/placeBid/place-bid.svg" style="width:0.28rem;margin-right: 0.08rem;" />
          <div>Place bid</div>
        </div>
        <div class="g-line"></div>
        <div class="bid-input-tip" style="text-align: center;">
          Current bid:
          <span>
            <big-number :number="currentBid" />
            <span>TCash</span>
          </span>
        </div>
      </div>

      <div class="unit-input">
        <div class="spaceBetween">
          <span class="word-sm"
            ><img
              src="@/assets/image/placeBid/right-bottom.svg"
              style="width:0.16rem;"
            />1 TCash = $ {{ TCASHPrice }}</span
          >
          <span class="word-sm"
            >Balance : <big-number :number.sync="balance"
          /></span>
        </div>
        <div class="spaceBetween exchange-item">
          <div class="spaceLeft unit-icon">
            <img
              src="@/assets/image/exchange/ustn-nobg.png"
              style="width:0.36rem;margin-right:0.08rem;"
            />
            <div class="word-sm-black">TCash</div>
          </div>
          <div style="flex:1 0 0;">
            <el-input
              class="exchange-input"
              placeholder="0.00"
              v-model="bidNum"
              @input="checkNumber"
              @blur="blurInput"
            />
            <div class="text-right word-sm-num">$ {{ changeMoney }}</div>
          </div>
        </div>
        <div class="bid-input-tip" style="text-align: right;" v-if="lastBid">
          My last bid
          <span class="">
            <big-number :number="lastBid" />
            <span class="unit">TCash</span>
          </span>
        </div>
      </div>
    </div>
    <div>
      <div class="spaceBetween" v-if="lastBid">
        <span class="word-sm">After</span>
        <div>
          <span style="font-size:0.22rem;color:#4C4C4C;margin-right:0.08rem;"
            ><big-number :number.sync="afterNum"
          /></span>
          <span class="word-sm">TCash</span>
        </div>
      </div>
      <check-login-btn
        style="margin-top:0.13rem"
        @clickHandle="submit"
        :label.sync="submitBtnText"
        :disabled="submitBtnText != 'Submit'"
      />
    </div>
  </div>
</template>

<script>
import checkLoginBtn from "@/components/CheckLoginBtn/index.vue";
import {
  /*getContractBid,*/
  getContractTCashAuction
} from "@/api/contract.js";
import { toBigNum, toBigItem, toSmallNum } from "@/utils/bigNumberTran.js";
import { isIntNum } from "@/utils/index.js"
import BigNumber from "bignumber.js";
import Web3 from "web3";

export default {
  components: { checkLoginBtn },
  props: {
    lastBid: {
      type: [String, Object, Number]
    }
  },
  data() {
    return {
      loading: false,
      bidNum: undefined,
      TCASHPrice: 0,
      balance: 0,
      account: this.$store.getters.metaMaskObj.account,
      /*contractBid: {},*/
      submitBtnText: "Enter an amount",
      web3: null,
      GAS_MULTIPLIER: 1.2
    };
  },
  computed: {
    changeMoney() {
      return (this.TCASHPrice * (+this.bidNum || 0)).toFixed(2);
    },
    afterNum() {
      const x = toBigItem(this.bidNum || 0);
      const y = new this.BigNumber(this.lastBid || 0);
      return x.plus(y);
    },
    currentBid() {
      let startAmount = this.$route.query.startAmount;
      let highValue = this.$route.query.highValue;
      if (+highValue !== 0) {
        return highValue;
      } else {
        return startAmount;
      }
    }
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        /*await getContractBid().then(res => {
          this.contractBid = res.data;
        });*/
        this.contractUnitPrice = this.$store.getters.contractMap["contractUnitPrice"].contract;
        this.contractUnitPriceAddress = this.$store.getters.contractMap["contractUnitPrice"].address;
        this.contractTCashAuction = this.$store.getters.contractMap["contractTCashAuction"].contract;
        this.contractTCashAuctionAddress = this.$store.getters.contractMap["contractTCashAuction"].address;
        // await getContractTCashAuction().then(res => {
        //   let resData = res.data.result;
        //   this.contractTCashAuction = new web3.eth.Contract(
        //     resData.abi,
        //     resData.address
        //   );
        //   this.contractTCashAuctionAddress = resData.address;
        // });
        this.contractTCash = this.$store.getters.contractMap["contractTCash"].contract;
        this.contractTCashAddress = this.$store.getters.contractMap["contractTCash"].address;
        this.Oracle = this.$store.getters.contractMap["contractOracle"].contract;
        this.OracleAddress = this.$store.getters.contractMap["contractOracle"].address;
        if (this.account) {
          this.getBalance();
          this.getTCashPrice();
        }
        this.loading = false;
      } catch (e) {
        console.dir(e);
        this.loading = false;
      }
    },
    async getBalance() {
      try {
        this.balance = await this.contractTCash.methods["balanceOf"](
          this.account
        ).call({
          from: this.account
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getTCashPrice() {
      try {
        let Oracleres = await this.Oracle.methods.getPriceData("TCASH").call({
          from: this.account
        });
        this.TCASHPrice = (Oracleres.price / 10000).toFixed(2);
      } catch (e) {
        console.log(e);
      }
    },
    blurInput() {
      if (!this.bidNum) return;
      
      // 移除所有非数字字符（保留小数点）
      let cleanValue = this.bidNum.toString().replace(/[^\d.]/g, '');
      
      // 处理多个小数点的情况，只保留第一个
      const dotIndex = cleanValue.indexOf('.');
      if (dotIndex !== -1) {
        cleanValue = cleanValue.substring(0, dotIndex + 1) + cleanValue.substring(dotIndex + 1).replace(/\./g, '');
      }
      
      // 检查是否为有效数字
      if (cleanValue === '' || cleanValue === '.' || isNaN(parseFloat(cleanValue))) {
        this.bidNum = '';
        return;
      }
      
      // 转换为数字后再转回字符串，自动去掉前导零和尾随零
      const numValue = parseFloat(cleanValue);
      
      // 如果数字为0或负数，清空输入
      if (numValue <= 0) {
        this.bidNum = '';
        return;
      }
      
      // 格式化数字，避免科学计数法，去掉不必要的零
      let formattedValue;
      
      // 检查是否为科学计数法
      const numStr = numValue.toString();
      if (numStr.includes('e') || numStr.includes('E')) {
        // 如果是科学计数法，使用 toFixed 并去掉尾随零
        formattedValue = numValue.toFixed(18).replace(/\.?0+$/, '');
      } else {
        formattedValue = numStr;
      }
      
      
      this.bidNum = formattedValue;
    },
    checkNumber() {
      if(!isIntNum(+this.bidNum)){
        this.$message.warning(`Please enter a number`);
        return false;
      }
      if (+this.bidNum <= 0) {
        this.bidNum = 0;
        this.submitBtnText = "Enter an amount";
        return false;
      } else if (toBigItem(this.bidNum).comparedTo(this.balance) > 0) {
        this.submitBtnText = "Insufficient REP/Unit balance";
        return false;
      } else if (this.lastBid.comparedTo(0) <= 0 && toBigItem(this.bidNum).comparedTo(this.currentBid) <= 0) {
        this.submitBtnText = "Less than current bid";
        return false;
      } else if (this.lastBid.comparedTo(0) > 0 && toBigItem(this.afterNum).comparedTo(this.currentBid) <= 0) {
        this.submitBtnText = "Less than current bid";
        return false;
      } else {
        this.submitBtnText = "Submit";
        return true;
      }
    },
    async submit(btn) {
      try {
        if (!this.checkNumber()) {
          return;
        }

        // 构建交易参数
        const txParams = {
          from: this.account,
          gas: await this.estimateGas(),
          gasPrice: await this.web3.eth.getGasPrice()
        };

        // 发送交易
        let res = await this.contractTCashAuction.methods.bid(
          this.$route.query.number,
          toBigNum(this.bidNum)
        ).send(txParams);

        btn.closeLoad();
        this.$message.success("You have made a successful bid!");
        this.$router.push("/TCashFinance/auction");
      } catch (error) {
        console.error('Bid transaction failed:', error);
        this.$message.error(error.message || 'Bid transaction failed');
        btn.closeLoad();
      }
    },
    // 估算gas
    async estimateGas() {
      try {
        const estimated = await this.contractTCashAuction.methods.bid(
          this.$route.query.number,
          toBigNum(this.bidNum)
        ).estimateGas({
          from: this.account
        });

        // 使用乘数增加一些额外的gas，以防止gas不足
        return Math.floor(estimated * this.GAS_MULTIPLIER);
      } catch (error) {
        console.error('Gas estimation failed:', error);
        // 如果估算失败，使用默认值
        return this.$store.getters.gas;
      }
    },
    refresh() {
      this.bidNum = undefined;
    }
  },
  created() {
    if (window.ethereum) {
      this.web3 = new Web3(window.ethereum);
    }
    this.init();
  }
};
</script>
<style scoped lang="scss">
.bid-now {
  // max-width: 5.6rem;
  border: 1px solid #272D38;
  min-height: 6.53rem;
  display: flex;
  flex-direction: column;
  margin-top: 0.42rem;
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);
  padding: 0.4rem 0.64rem;
  border-radius: 0.4rem;

  >>> .el-loading-mask {
    background-color: rgba(0, 0, 0, .6);
  }

  >>> .el-loading-spinner .path {
    stroke: #2675f1;
  }
}
.bid-title {
  font-size: 0.32rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #ECECEC;
  line-height: 0.38rem;
  margin-bottom: 0.75rem;
  svg {
    margin-right: 0.12rem;
    width: 0.28rem;
  }
}
.unit-input {
  .exchange-item {
    background: rgba(255,255,255,0.05);
    padding: 0.24rem 0.2rem;
    // min-width: 5.6rem;
    border-radius: 8px;
    margin-bottom: 0.16rem;
    border: 1px solid rgba(255,255,255,0.25);
  }
  .exchange-jiantou {
    width: 0.56rem;
    position: absolute;
    left: 50%;
    margin-left: -0.28rem;
    margin-top: -0.34rem;
  }
  .exchange-input {
    /deep/ .el-input__inner {
      border: none;
      text-align: right;
      font-size: 0.34rem;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #fff;
      padding: 0 0;
      background-color: transparent;
    }
  }
  .word-sm {
    font-size: 0.18rem;
    font-weight: 400;
    color: #aaaaaa;
    line-height: 0.2rem;
    margin-bottom: 0.13rem;
  }
  .word-sm-black {
    font-size: 0.2rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
  .word-big-num {
    font-size: 0.36rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #1f1f1f;
    line-height: 0.42rem;
  }
  .unit-icon {
    padding: 0.18rem 0.16rem;
    border-radius: 0.08rem;
  }
}
.bid-input-tip {
  font-size: 0.22rem;
  font-weight: 400;
  color: #929dad;
  line-height: 0.32rem;
  margin-top: 0.26rem;
  & > span > .big-number {
    font-size: 0.24rem;
    color: #ECECEC ;
    margin: 0 0.04rem;
  }
  & > span > span {
    font-size: 0.18rem;
    color: #929dad;
    margin-left: 0.04rem;
  }
}
.word-sm {
  font-size: 0.18rem;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 0.2rem;
}
.word-sm-num {
  font-size: 0.19rem;
  color: #929DAD;
  font-weight: 400;
}
.g-line {
  height: 1px;
  margin: .3rem -0.64rem 0;
  background-color: rgba(146, 157, 173, .2);
}
</style>
